import { Controller } from "@hotwired/stimulus"
import { debounce } from "../application"

export default class extends Controller {
    static targets = ["input", "frame"]
    static outlets = ["onboarding"]

    connect() {
        this.debouncedSearch = debounce(() => this.performSearch(), 300)
    }

    search() {
        this.debouncedSearch()
    }

    performSearch() {
        if (!this.hasFrameTarget) return

        const platform = this.hasOnboardingOutlet ? this.onboardingOutlet.referralSourceValue : ""
        if (!platform) return

        const url = new URL("/marketing/influencers/search", window.location.origin)
        url.searchParams.set("platform", platform)
        url.searchParams.set("q", this.inputTarget.value)

        this.frameTarget.src = url.toString()
    }
}
